<header class="relative px-4 pb-4 pt-2">
  <h1 class="text-2xl font-semibold text-greyscale-900">Update Notes</h1>
  <p class="text-sm text-greyscale-600">
    Release notes shown to users on /home/updates and in the "what's new" popup
  </p>
  <div class="absolute right-4 top-2 flex items-center gap-2">
    <p-button label="Add update note" icon="pi pi-plus" routerLink="create" />
  </div>
</header>

<main class="p-4">
  @if (updateNoteService.error()) {
    <div class="mb-4 rounded border border-red-200 bg-red-50 p-3 text-red-700">
      Could not load the update notes.
    </div>
  }

  <p-table
    [value]="updateNoteService.notes()"
    [loading]="updateNoteService.isLoading()"
    [paginator]="true"
    [rows]="10"
  >
    <ng-template #header>
      <tr>
        <th>Released at</th>
        <th>Type</th>
        <th>Content (FR)</th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template #body let-note>
      <tr>
        <td>{{ note.releasedAt | date: "yyyy-MM-dd" }}</td>
        <td>{{ note.type }}</td>
        <td
          [pTooltip]="note.contentFR"
          tooltipPosition="top"
          [style.white-space]="'pre-line'"
        >
          {{ preview(note) }}
        </td>
        <td>
          <div class="flex items-center justify-end gap-1">
            <p-button
              icon="pi pi-pencil"
              [text]="true"
              size="small"
              severity="secondary"
              routerLink="edit/{{ note.id }}"
            />
            <p-button
              icon="pi pi-trash"
              [text]="true"
              size="small"
              severity="danger"
              (onClick)="confirmDelete(note)"
            />
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      <tr>
        <td colspan="4" class="p-6 text-center text-greyscale-600">
          No update note yet.
        </td>
      </tr>
    </ng-template>
  </p-table>
</main>
